import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Common } from "../../../../common/src";

type StatusTextProps = {
  status: Common.PROJECT_STATUS_LIST;
  isLanguage: boolean;
  wrapTwoLines?: boolean;
};

export const StatusText = (props: StatusTextProps) => {
  const { t } = useTranslation();
  const text = () => {
    let helmertError = false;

    if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      if (
        !(
          props.status.helmert_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED ||
          props.status.coordinate_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED
        )
      ) {
        helmertError = true;
      }
    }

    if (props.status.is_ar) {
      switch (props.status.ar_processing) {
        case Common.PROJECT_STATUS_ENUM.COMPLETED:
        case Common.PROJECT_STATUS_ENUM.INCOMPLETE:
          return t("AR_UPLOAD_COMPLETE");
        case Common.PROJECT_STATUS_ENUM.PROCESSING:
          return t("AR_UPLOAD_CONVERTING");
        case Common.PROJECT_STATUS_ENUM.ERROR:
          return t("AR_UPLOAD_FAILED");
      }
    } else if (helmertError) {
      return t("COORDINATE_CHANGE_ERROR");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      return t("SFM_PROCESSING_ERROR");
    } else if (props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR) {
      return t("UPLOAD_ERROR");
    } else if (
      props.status.dashboard_upload_las_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_las_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("DASHBOARD_UPLOAD_COMPLETE");
    } else if (
      props.status.verification_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.verification_sfm === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("ACCURACY_VERIFY_COMP");
    } else if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("COORDINATE_CHANGE_COMPLETE");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("PROCESSING_DONE");
    } else if (
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.WAITING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.PROCESSING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.WAITING
    ) {
      return t("UPLOAD_COMPLETE");
    } else {
      return "";
    }
  };
  return (
    <Typography
      variant="body2"
      component="div"
      sx={
        props.wrapTwoLines
          ? {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              whiteSpace: "pre-line",
              lineHeight: 1.3,
              wordBreak: "break-word",
            }
          : {
              display: "flex",
              alignItems: "center",
              height: "28px",
              lineHeight: "1.0",
            }
      }
    >
      {text()}
    </Typography>
  );
};

export default StatusText;
